import { render, staticRenderFns } from "./AppLeftMenu.vue?vue&type=template&id=4565e037&scoped=true"
import script from "./AppLeftMenu.vue?vue&type=script&lang=js"
export * from "./AppLeftMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4565e037",
  null
  
)

export default component.exports